export const environment = {
    production: true,
    showGithubLogo: true,
    apiOrigin: '',
};
